import React, { Component, Fragment } from 'react'
import { Card, Col, Icon, Input, Row, Spin, Timeline } from 'antd'
import Posts from '../../../api/Posts'
import { strVal } from '../../../modules/Utils'
import Authentication from '../../../modules/Authentication'
import 'video-react/dist/video-react.css'
import PostViewCard from './PostViewCard/PostViewCard'
import _ from 'lodash'
import Post from './Post'
import Notices from '../../../components/Main/Notices'
import styled from 'styled-components'

const Search = Input.Search
export const PostCard = styled(Card)`
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
`
class WallTimeLine extends Component {
  constructor() {
    super()
    this.api = new Posts()
    this.state = {
      loading: false,
      fetching: false,
      data: [],
      list: [],
      currentList: [],
      postShow: false,
    }
    this.initialNo = 4
    this.lastPost = 4
    this.auth = new Authentication()
  }

  async componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
    await this.fetch()
  }

  fetch = async () => {
    this.setState({ fetching: true })
    let response = await this.api.list()
    let list = await response.json()
    let currentList = list.slice(0, this.initialNo)
    currentList = await this.getPreview(currentList)
    this.setState({ data: list, list, currentList, fetching: false })
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleMore = async () => {
    this.setState({ loading: true })
    let currentList = [...this.state.currentList]
    let appended = this.state.list.slice(this.lastPost, this.lastPost + 5)
    this.lastPost += 5
    currentList.push(...appended)
    currentList = await this.getPreview(currentList)
    this.setState({ currentList, loading: false })
  }
  getPreview = async (currentList) => {
    const results = await this.api.preview(currentList)
    return results
  }
  handleOnSearch = async (e) => {
    this.setState({ loading: true })
    let filtered = this.state.data
      .map((a) => a)
      .filter((row) => {
        return (
          strVal(row, 'post.post').toUpperCase().includes(e.target.value.toUpperCase()) ||
          strVal(row, 'owner.nickname').toUpperCase().includes(e.target.value.toUpperCase())
        )
      })
    let currentList = filtered.slice(0, this.initialNo)
    currentList = await this.getPreview(currentList)
    this.setState({ loading: false, list: filtered, currentList })
  }
  handleScroll = () => {
    const windowHeight = 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight
    const body = document.body
    const html = document.documentElement
    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    )
    const windowBottom = windowHeight + window.pageYOffset
    if (windowBottom >= docHeight) {
      setTimeout(this.handleMore, 1000)
    }
  }
  changeView = () => {
    this.setState({ showPost: !this.state.showPost })
  }
  handelRefresh = () => {
    let r = this.state.refresh
    r++
    this.setState({ refresh: r })
    this.fetch()
    this.setState({ showPost: false })
  }

  render() {
    const { currentList } = this.state
    const userID = _.get(this.auth.getProfile(), 'partner.member._id')
    return (
      <Fragment>
        <Row key="1" style={{ minHeight: 50, padding: 20, marginLeft: 10, marginRight: 10 }}>
          <Col span={2}>
            <Icon
              style={{ fontSize: '28px', cursor: 'pointer' }}
              type={!this.state.showPost ? 'plus-circle' : 'minus-circle'}
              onClick={this.changeView}
              theme="twoTone"
            />
          </Col>
          <Col span={20}>
            <strong style={{ fontSize: '14pt', marginLeft: 10 }}>Activity Stream</strong>
          </Col>
          <Col offset={1} span={1}>
            <Icon
              style={{
                fontSize: '26px',
                color: '#1890ff',
                cursor: 'pointer',
                float: 'right',
              }}
              type="sync"
              onClick={this.fetch}
            />
          </Col>
        </Row>
        {this.state.showPost && (
          <Row style={{ margin: 20 }}>
            <PostCard style={{ width: '100%' }}>
              <Post refresh={this.handelRefresh} />
            </PostCard>
          </Row>
        )}
        <Notices />
        <Row style={{ marginLeft: 10, marginRight: 10 }}>
          {!this.state.fetching && (
            <Timeline>
              {currentList.map((l) => {
                return (
                  <Timeline.Item key={l.post._key}>
                    <PostViewCard userID={userID} post={l} refresh={this.handelRefresh} />
                  </Timeline.Item>
                )
              })}
              <Timeline.Item key={'see-more'}>
                <a onClick={this.handleMore}>See more</a>
              </Timeline.Item>
            </Timeline>
          )}
          <Spin
            indicator={<Icon type="loading" style={{ fontSize: 50 }} spin />}
            spinning={this.state.fetching || this.state.loading}>
            <Col span={24} />
          </Spin>
        </Row>
      </Fragment>
    )
  }
}

export default WallTimeLine
